import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

// Import components
import wsLogo from '../assets/images/wonderschool/logo-base.png';
import { getTitlePrefix } from '../config/env';
import Loading from './Loading';

const ExternalRedirect = ({ externalUrl, shouldUseReplace }) => {
  const { t } = useTranslation();
  const [didTimeout, setDidTimeout] = useState(false);

  const renderPageHead = () => (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {t('navigation.redirect.browserTitle')}
      </title>
      <body className="auth redirect" />
    </Helmet>
  );

  useEffect(() => {
    let stillMounted = true;
    if (!didTimeout) {
      setTimeout(() => {
        if (stillMounted && !didTimeout) {
          setDidTimeout(true);
          if (shouldUseReplace) {
            window.location.replace(externalUrl);
          } else {
            window.location.assign(externalUrl);
          }
        }
      }, 200); // Give things a little time to settle before committing to the redirect. Makes things less jittery
    }
    return () => {
      stillMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalUrl]);

  return (
    <div className="container mx-auto px-4 py-8">
      {renderPageHead()}

      <div className="rounded-lg bg-white p-8 text-center shadow-md">
        <img src={wsLogo} alt={t('navigation.redirect.logoAlt')} className="mx-auto mb-4 h-16 w-auto" />
      </div>

      {didTimeout ? (
        <Loading>
          <a href={externalUrl}>{t('navigation.redirect.manualAction')}</a>
        </Loading>
      ) : (
        <Loading>{t('navigation.redirect.status')}</Loading>
      )}
    </div>
  );
};

export default ExternalRedirect;
